import React, { useState } from 'react';
import styles from './M_ProfileMobileTabs.module.css';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import cn from 'classnames';
import Q_BlurEffect from '@/components/Q_Quarks/Q_BlurEffect/Q_BlurEffect';
import M_ProfileMobileTabsMenu from './M_ProfileMobileTabsMenu';

type ProfileTab =
  | 'profile'
  | 'security'
  | 'privacy'
  | 'notifications'
  | 'billing'
  | 'wallet';

interface M_ProfileMobileTabsProps {
  activeTab: ProfileTab;
  onTabChange: (tab: ProfileTab) => void;
  onLogout: () => void;
}

export default function M_ProfileMobileTabs({
  activeTab,
  onTabChange,
  onLogout,
}: M_ProfileMobileTabsProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const tabs = [
    {
      id: 'profile' as ProfileTab,
      icon: Q_Icon.ProfileIcon,
    },
    {
      id: 'security' as ProfileTab,
      icon: Q_Icon.SecurityIcon,
    },
    {
      id: 'privacy' as ProfileTab,
      icon: Q_Icon.PrivacyIcon,
    },
    {
      id: 'notifications' as ProfileTab,
      icon: Q_Icon.NotificationsIcon,
    },
    {
      id: 'billing' as ProfileTab,
      icon: Q_Icon.ThreePointsIcon,
    },
  ];

  const handleTabClick = (tab: ProfileTab) => {
    if (tab === 'billing') {
      setIsMenuOpen(true);
    } else {
      onTabChange(tab);
    }
  };

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          {tabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                className={cn(
                  styles.tab,
                  activeTab === tab.id && styles.active
                )}
                onClick={() => handleTabClick(tab.id)}
                aria-label={tab.id}
              >
                <Icon width={24} height={24} fill='none' />
              </button>
            );
          })}
        </div>
        <Q_BlurEffect yAxis='bottom' />
      </div>

      <M_ProfileMobileTabsMenu
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        activeTab={activeTab}
        onTabChange={onTabChange}
        onLogout={onLogout}
      />
    </>
  );
}
